import { buildSecrets } from "./environment.secrets";

export const environment = {
    production: false,
    apiBaseUrl: "https://boosttaxi-sandbox-api.herokuapp.com/backoffice",
    socketIo: "https://boosttaxi-sandbox-api.herokuapp.com/booking",
    sentryDsn: buildSecrets.sentryDsn,
    environment: "sandbox",
    release: "boosttaxi-admin@1.0.3",
    googleMapsApiKey: buildSecrets.googleMapsApiKey,
};
